import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { useParams } from "react-router-dom";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { FaPlus } from "react-icons/fa6";
import React, { FormEvent, useState } from "react";
import ModalButton from "../../../components/common/form/ModalButton";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import AddEditReswareTypeMappingsForm from "./modals/AddOrEditReswareTypeMappings";
import { useDeleteReswareTypeMappingMutation, useSearchReswareTypeMappingsQuery } from "./integrationsApi";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";

const ReswareTypeMapping = () => {

    let { customerId } = useParams();
    const [showAssociationFeeUpdate, setShowAssociationFeeUpdate] = useState(false);
    const [mappingId, setMappingId] = useState("");
    const [deleteApi, { isLoading: deleteApiResponse }] = useDeleteReswareTypeMappingMutation();

    const handleDeleteSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (mappingId) {
            await handleRTKQuery(
                () => deleteApi({ customerId, mappingId }).unwrap(),
                (isSuccess: any) => {
                    if (isSuccess) setMappingId("");
                }
            );
        }
    };
    let columns: DataTableColumn[] = [
        {
            label: "Type", accessor: "type",
            cell: (props: any) => {
                return (
                    <span
                        className="column-link active cursor"
                        style={{ color: "#007BFF", cursor: "pointer" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setMappingId(props.row.original.id);
                            setShowAssociationFeeUpdate(true);
                        }}
                    >
                        {props.value}
                    </span>
                );
            }
        },
        { label: "Map From", accessor: "mapFrom" },
        { label: "Map To", accessor: "mapTo" },
        { label: "Map To ReOrder", accessor: "mapToReorder" },
        {
            label: hasPermission(["RESW-D"]) ? "Action" : <span/>,
            accessor: "id",
            canSort: false,
            cell: (props: any) => (
                hasPermission(["RESW-D"]) && props.row.original.id && (
                    <div className="ml-4">
                        <ModalButton
                            triggerButton={
                                <FaTrash
                                    className="cursor-pointer text-surface-0 text-lg hover:text-highlight-7"
                                    title="Delete Resware Credentials"
                                />
                            }
                            onOpen={() => setMappingId(props.row.original.id)}
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title="Delete Resware Type Mapping"
                                    bodyMessage="Are you sure you want to delete this Resware Type Mapping?"
                                    onSubmit={handleDeleteSubmit}
                                    isLoading={deleteApiResponse}
                                />
                            }
                        />
                    </div>
                )
            )
        },

    ]

    return (
        <>
            {hasPermission(["RESW-C"]) &&
                <div className={"flex justify-end"}>

                    <ModalButton
                        triggerButton={
                            <div
                                className="h-7 w-10 text-text-0  rounded-md bg-highlight-0 flex justify-center items-center cursor-pointer  absolute top-0 left-auto">
                                <FaPlus />
                            </div>
                        }
                        onOpen={() => {
                        }}
                        modal={
                            <AddEditReswareTypeMappingsForm
                                show={true}
                                setShow={() => {
                                }}
                                customerId={customerId}
                            />
                        }
                    />
                </div>
            }

            <div className=''>
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchReswareTypeMappingsQuery
                    }}
                    defaultFilter={{
                        "customerId": customerId
                    }}
                    defaultSortOptions={{
                        accessor: "creationDate",
                        direction: "desc"
                    }}
                    appendFilterToUrl={false}
                    basePermission={"RESW"}
                ></DataTable>
                {showAssociationFeeUpdate && (
                    <AddEditReswareTypeMappingsForm
                        show={showAssociationFeeUpdate}
                        setShow={setShowAssociationFeeUpdate}
                        customerId={customerId}
                        mappingId={mappingId}
                    />
                )}
            </div>
        </>
    )
}

export default ReswareTypeMapping;